import { defineComponent as k, ref as T, onMounted as x, onUnmounted as y, createBlock as v, openBlock as o, createSlots as g, withCtx as r, createElementBlock as c, Fragment as h, renderList as C, createVNode as n, unref as w } from "vue";
import { MsCheckCircle as S } from "@sunrise/icons";
import { screenSizeDetection as b, sourcePoint as m } from "@sunrise/shared";
import { trackWithBaseTracking as M } from "@sunrise/tracking";
import { TCF as O } from "@sunrise/types";
import B from "./index605.js";
import l from "./index192.js";
import { useStoredInterval as D } from "./index606.js";
const H = /* @__PURE__ */ k({
  __name: "HydratedAppModal",
  props: {
    linkText: {},
    features: {},
    headerText: {},
    headline: {}
  },
  setup(I) {
    const a = T(!1), { isScreenM: p } = b(), { startInterval: d, clearSessionInterval: u } = D(() => {
      a.value = !p.value;
    });
    x(async () => {
      const e = await m.onConsentAvailablePromise();
      m.hasConsent(O.Purpose.STORAGE, e) && d();
    }), y(() => u());
    function f() {
      s("buttonclick_close");
    }
    function _() {
      s("buttonclick_download");
    }
    function s(e) {
      M({
        mslayer_element_data_id: "ed0000314",
        mslayer_element_text: `downloadapp + ${window.utag_data.mslayer_page_level_2}`,
        mslayer_element_type_text: e,
        mslayer_element_variant: "default",
        mslayer_element_body_type: "overlay"
      });
    }
    return (e, i) => (o(), v(B, {
      isOpen: a.value,
      "onUpdate:isOpen": i[0] || (i[0] = (t) => a.value = t),
      "header-text": e.headerText,
      onDownloadClick: _,
      onClose: f
    }, g({
      headline: r(() => {
        var t;
        return [
          n(l, {
            tagType: "span",
            contentTag: (t = e.headline) == null ? void 0 : t.text
          }, null, 8, ["contentTag"])
        ];
      }),
      features: r(() => [
        (o(!0), c(h, null, C(e.features, (t) => (o(), c("p", {
          key: t.cmsId,
          class: "flex gap-8 mb-8 text-text-l"
        }, [
          n(w(S), { class: "w-24 h-24 shrink-0 text-color-alert-positive-100" }),
          n(l, {
            contentTag: t.text
          }, null, 8, ["contentTag"])
        ]))), 128))
      ]),
      _: 2
    }, [
      e.linkText ? {
        name: "linkText",
        fn: r(() => [
          n(l, {
            contentTag: e.linkText.text
          }, null, 8, ["contentTag"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["isOpen", "header-text"]));
  }
});
export {
  H as default
};
